import * as React from 'react';
import { Component } from 'react';
import { isObservableArray, computed } from 'mobx';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import StarRating from './StarRating';
import SRRI from './SRRI';
import ChangeIndicator from './ChangeIndicator';
import Translate from './Translate';
import { StringOrNumber, IconAlignment } from '../types';
import { ShowChange } from '../models/configuration/ShowChange';
import { DataStore } from '../stores';
import { Theme } from '../models/Theme';

const FundFactItem = styled<any, any>('span', 'fundFactItem', 'fundFactValue')`
    ${propStyles}
`;

interface FundFactValueProps {
    dataStore: DataStore;
    theme?: Theme;
    value: StringOrNumber | Array<StringOrNumber>;
    ui?: 'srri' | 'stars' | 'starsOutOf';
    separator?: string;
    showChange?: boolean | ShowChange;
    higherRiskLabel?: string;
    lowerRiskLabel?: string;
    alignIcon?: IconAlignment;
    upIcon?: string;
    downIcon?: string;
    noDataPlaceholder?: string;
}

@observer
class FundFactValue extends Component<FundFactValueProps> {
    constructor(props) {
        super(props);
    }

    @computed
    get changeIndicator() {
        const {
            dataStore,
            value,
            alignIcon,
            showChange,
            upIcon = 'FundFactChangeUpIcon.svg',
            downIcon = 'FundFactChangeDownIcon.svg',
        } = this.props;

        return (
            showChange && (
                <ChangeIndicator
                    dataStore={dataStore}
                    value={value as number}
                    alignIcon={alignIcon}
                    upIcon={upIcon}
                    downIcon={downIcon}
                    showChange={typeof showChange !== 'boolean' && showChange}
                />
            )
        );
    }

    render() {
        const {
            ui,
            value,
            separator,
            showChange,
            higherRiskLabel,
            lowerRiskLabel,
            noDataPlaceholder,
            theme,
        } = this.props;

        if (ui === 'srri' && typeof value === 'number') {
            return (
                <SRRI
                    rating={value}
                    higherRiskLabel={higherRiskLabel}
                    lowerRiskLabel={lowerRiskLabel}
                />
            );
        }

        if (ui === 'stars' || ui === 'starsOutOf') {
            return (
                <StarRating
                    showEmptyStars={ui === 'starsOutOf'}
                    rating={value as StringOrNumber}
                    noDataPlaceholder={noDataPlaceholder}
                />
            );
        }

        return (
            <FundFactItem {...theme.FundFactValueItem}>
                {showChange ? (
                    this.changeIndicator
                ) : isObservableArray(value) ? (
                    (value as Array<StringOrNumber>).join(separator || ', ')
                ) : (
                    <Translate>{value}</Translate>
                )}
                {separator}
            </FundFactItem>
        );
    }
}

export default withTheme(FundFactValue);



// WEBPACK FOOTER //
// ./src/Components/FundFactValue.tsx